const pageTableCounter = new WeakMap()

export function getAutoTableIndex(vm) {
  const pageVm = findPageVm(vm)
  const current = pageTableCounter.get(pageVm) || 0
  const next = current + 1

  pageTableCounter.set(pageVm, next)

  return next
}

export function getAutoDragColumnKey(vm, tableIndex) {
  const routeKey = vm.$route?.name || vm.$route?.path || 'unknown-route'
  const pageVm = findPageVm(vm)
  const pageKey =
    pageVm?.$options?.__file || pageVm?.$options?.name || 'unknown-page'

  return `auto:${routeKey}:${pageKey}:${tableIndex}`
}

function findPageVm(vm) {
  let current = vm

  while (current) {
    const file = current.$options?.__file || ''

    if (/src[\\/](views|pages)[\\/]/.test(file)) {
      return current
    }

    current = current.$parent
  }

  return vm.$root || vm
}
